import { Fragment } from "react";
import { Outlet } from "react-router-dom";
import NavBarWithSearch from "../utilities/NavBarWithSearch";
import { landingPageVideoURL } from "../config/Constants";
import Footer from "../utilities/Footer";
import "../../style.css";

const HomeContentLayout = () => {
  return (
    <Fragment>
      <div>
        <div className="home-video-conatiner">
          <video
            width="100%"
            height="100%"
            style={{
              objectFit: "cover",
              zIndex: "-2",
              opacity: 0.5,
            }}
            preload="true"
            disablePictureInPicture
            controlsList="nodownload"
            autoPlay
            muted
            loop
          >
            <source src={landingPageVideoURL} type="video/mp4" />
          </video>
          <NavBarWithSearch />
          <div className="home-video-text">
            Explore Dota2 <br />
            Insights...
          </div>
          <div className="shadow-container-btm"></div>
        </div>
      </div>
      <div className="home-content">
        <Outlet />
      </div>
      <Footer />
    </Fragment>
  );
};

export default HomeContentLayout;
